<template>
  <div class="answerReply">
    <van-empty
      v-if="emptyed"
      description="暂无我的提问信息"
      style="margin-top: 20px; background: #fff"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
      :offset="50"
      v-else
    >
      <div class="contentBox">
        <div
          @click="getDetail(item.id)"
          class="content"
          v-for="item in list"
          :key="item.id"
        >
          <div class="content-top">
            <div class="profile">
              <img
                v-if="item.avatar"
                :src="item.avatar"
                alt
                style="width: 44px; height: 44px; border-radius: 50%"
              />
              <img
                v-else
                src="../../assets/portrait.png"
                alt
                style="width: 44px; height: 44px; border-radius: 50%"
              />
              <!-- <span class="name"> {{ getSwitchChecked(item) }}用户</span> -->
              <span class="name"> {{ item.nickName }}</span>
            </div>
            <div class="time">{{ item.createTime }}</div>
          </div>
          <div class="content-center">
            <span class="type">类型：</span>
            <span class="name">{{ getProblemType(item.problemType) }}</span>
          </div>
          <div class="content-bottom">
            <div class="description">描述：{{ item.message }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { listProblem } from "../../api/user";

export default {
  name: "answerReply",
  data() {
    return {
      type: 0,
      token: "",
      loading: false,
      hasMore: true, //有更多数据
      pageNum: 1,
      pageSize: 10,
      list: [],
      emptyed: true,
      finished: false,
      gridData: [], // 咨询师回答内容
      columns: [
        "心理健康",
        "两性心理",
        "亲子教育",
        "情绪问题",
        "压力管理",
        "家庭关系",
        "婚恋情感",
        "人际关系",
        "个人成长",
        "职业发展",
      ],
    };
  },

  created() {
    this.getProblemType();
    if (this.$route.query.type == 0) {
      this.type = 0;
    } else if (this.$route.query.type == 1) {
      this.type = 1;
    }
    this.getList();
  },
  methods: {
    getDetail(problemId) {
      this.miniJump(`/answerDetail?problemId=${problemId}`)
    },
    getProblemType(type) {
      for (var i = 0; i < this.columns.length; i++) {
        if (i == type) {
          return this.columns[i];
        }
      }
    },
    getSwitchChecked(item) {
      if (item.switchChecked == "0") {
        return "匿名";
      } else {
        return item.userName;
      }
    },
    loadMore() {
      if (!this.hasMore) {
        //没有更多数据了
        this.loading = this.finished = true; //关闭无限滚动
        return false;
      }
      this.getList();
    },
    onLoad() {
      if (!this.hasMore) {
        //没有更多数据了
        this.loading = this.finished = true; //关闭无限滚动
        return false;
      }
      this.getList();
    },
    getList() {
      let userId = localStorage.getItem("userId");
      this.emptyed = false;
      this.loading = true; //关闭无限滚动
      let { pageNum, pageSize } = this;
      listProblem({
        pageNum,
        pageSize,
        userId: userId,
      })
        .then((res) => {
          this.list = this.list.concat(res.rows);
          this.loading = false; //开启无限滚动
          if (this.list.length === 0) {
            this.emptyed = true;
          }
          if (pageNum * pageSize >= res.total) {
            this.hasMore = false;
            return;
          }
          this.pageNum++;
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.answerReply {
  background: rgb(247, 246, 247);
  min-height: 100vh;
  .mind_top {
    background: #577eff;
    z-index: 99;
    text-align: center;
    font-size: 10px;
  }
  .contentBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .content {
      display: flex;
      flex-direction: column;
      width: 90%;
      background: #fff;
      border-radius: 10px;
      margin: 10px 0;
      padding: 0 0 10px 0;
      .content-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px;
        .profile {
          display: flex;
          align-items: center;
          .name {
            margin: 0 15px;
            font-size: 16px;
            font-weight: 600;
            color: rgb(61, 61, 61);
          }
        }
        .time {
          font-size: 14px;
          font-weight: 600;
          color: rgb(162, 162, 162);
        }
      }
      .content-center {
        display: flex;
        margin: 0 20px;
        .type {
          font-size: 15px;
          font-weight: 600;
          color: rgb(159, 159, 158);
        }
        .name {
          font-size: 14px;
          font-weight: 600;
          color: rgb(102, 102, 102);
        }
      }
      .content-bottom {
        display: flex;
        margin: 10px 20px;
        .description {
          font-size: 14px;
          line-height: 25px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>